export class MapaRe {
    constructor() {}
    commonStep = 'stepper.form.commun.mapa.step';
    step = 'stepper.form.mapa_re.step';

  }
